import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as companyGroupService from "../../services/companyGroupService";
import { handleApiError } from "../storeEffects";
import { CompanyGroupAction, companyGroupFailure, companyGroupSuccess } from "./storeCompanyGroup";

export type CompanyGroupThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, CompanyGroupAction>

export const getCompanyGroupsPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return companyGroupService.getCompanyGroupPage()
        .then(
            companyGroupPage => {
                dispatch(companyGroupSuccess(companyGroupPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(companyGroupFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};